import { SocotraNetwork } from "juneojs";

const DEFAULD_NETWORK = SocotraNetwork;

export default DEFAULD_NETWORK;
